export default "__VITE_ASSET__B42PUBFz__"